<template>
  <div class="performance" v-loading="pageLoading">
    <div class="performance-card">
      <div class="sales-sec">
        <div class="sales-block">
          <div class="sales-head">Sales</div>
          <div class="sales-amount">
            {{
              summary.total_sales
                ? "INR " + summary.total_sales.toFixed(2)
                : "0"
            }}
          </div>
        </div>
        <div class="sales-block">
          <div class="sales-head">NOB</div>
          <div class="sales-amount">
            {{ summary.trans ? summary.trans.toFixed(2) : "0" }}
          </div>
        </div>
        <div class="sales-block" style="width: 150px">
          <div class="sales-head">IPT</div>
          <div class="sales-amount">
            {{ summary.ipt ? summary.ipt.toFixed(2) : "0" }}
          </div>
        </div>
        <div class="sales-block" style="width: 220px">
          <div class="sales-head">Average Sales Price(ASP)</div>
          <div class="sales-amount">
            {{ summary.asp ? summary.asp.toFixed(2) : "0" }}
          </div>
        </div>
        <div class="sales-block">
          <div class="sales-head">Average NOB</div>
          <div class="sales-amount">
            {{ summary.adt ? summary.adt.toFixed(2) : "0" }}
          </div>
        </div>
        <div class="sales-block" style="width: 220px">
          <div class="sales-head">Average Bill Value (ABV)</div>
          <div class="sales-amount">
            {{ summary.ats ? "INR " + summary.ats.toFixed(2) : "0" }}
          </div>
        </div>
      </div>
      <div class="tab mt-2">
        <div class="flex items-center flex-wrap">
          <div class="box-300 ml-4 mr-2">
            <p class="input-label">Location</p>
            <!-- <div v-if="selectedCountry.length && user_access_level == 'admin'">
              <BaseLocationsSingleSelect
                class="dropDown"
                :selected-location="selectedCountry"
                @update="dropDownUpdate"
              ></BaseLocationsSingleSelect>
            </div> -->
            <div>
              <BaseLocationsSingleSelect
                class="dropDown"
                @update="dropDownUpdate"
              />
            </div>
          </div>

          <div class="special-option">
            <base-categories-dropdown
              class="mdms"
              @categoryUpdate="categoryDropDownUpdate"
              style="width: 200px"
            />
          </div>

          <div class="special-option">
            <p class="input-label">Report</p>
            <el-select
              v-model="view"
              style="max-width: 200px"
              placeholder="Select"
              @change="showDateByQueryReport(view)"
            >
              <el-option
                v-for="(item, index) in viewList"
                :key="index"
                :value="item.id"
                :label="item.name"
              >
                {{ item.name }}
              </el-option>
            </el-select>
          </div>

          <div class="special-option">
            <p class="input-label">From Date</p>
            <el-date-picker
              v-model="fromDate"
              v-validate="'required'"
              type="date"
              value-format="yyyy-MM-dd"
              style="max-width: 170px"
              placeholder="Pick a day"
              name="fromDate"
              :disabled="view != 'daily' && view != 'customDt'"
              :picker-options="datePickerOptions"
            >
            </el-date-picker>
            <p>
              <span
                :v-show="errors.has('fromDate')"
                class="text-red-dark text-xs"
              >
                {{ errors.first("fromDate") ? "This field is required." : "" }}
              </span>
            </p>
          </div>

          <div class="special-option">
            <p class="input-label">To Date</p>
            <el-date-picker
              v-model="toDate"
              v-validate="'required'"
              value-format="yyyy-MM-dd"
              type="date"
              style="max-width: 170px"
              placeholder="Pick a day"
              name="toDate"
              :disabled="view != 'daily' && view != 'customDt'"
              :picker-options="disabledStartDate"
            >
            </el-date-picker>
            <p>
              <span
                :v-show="errors.has('toDate')"
                class="text-red-dark text-xs"
              >
                {{ errors.first("toDate") ? "This field is required." : "" }}
              </span>
            </p>
          </div>
          <div class="special-option" style="margin-top: 30px">
            <!-- margin-left: auto; -->
            <el-button
              size="small"
              class="toggle-btn"
              style="
                min-width: 90px;
                height: 35px;
                background: #e29d5a;
                color: #ffff;
                border: 1px solid;
              "
              @click="getPerformanceData()"
              >Go</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="performance-tbl">
      <div class="breadcrumbs">
        <div class="breadcrumbs-inn">
          <div
            class="breadcrumbs-inn"
            v-for="(i, index) in breadcrumbs"
            :key="index"
          >
            <div
              class="item"
              v-if="i.type"
              @click="changeTblData(i.name, i.id, i.type)"
            >
              {{ i.name }}
            </div>
            <i class="el-icon-arrow-right" v-if="i.type"></i>
          </div>
        </div>

        <div class="csv-outer cursor-pointer" v-loading="isCSVDownloading">
          <div class="csv-btn"  @click="reportCSVDownload()">
            CSV <i class="el-icon-download"></i>
          </div>
        </div>
      </div>

      <div class="event-table" v-loading="loading">
        <table>
          <thead>
            <tr>
              <th v-if="view == 'daily'">
                Date

                <span>
                  <i
                    v-if="sort_by_ascending_date"
                    class="el-icon-caret-top text-base cursor-pointer"
                    @click="sortByDescendingDate()"
                  ></i>

                  <i
                    v-else
                    class="el-icon-caret-bottom text-base cursor-pointer"
                    @click="sortByAscendingDate()"
                  ></i>
                </span>
              </th>
              <th v-if="basics == 'employee'">
                Emp Id

                <el-popover placement="bottom" trigger="click">
                  <div>
                    <el-checkbox-group v-model="selected_emp_id">
                      <el-checkbox
                        v-for="(empId, id_index) in empIdArray"
                        :key="id_index"
                        class="mb-2 checkbox-lable"
                        :label="empId.text"
                        style="display: block"
                        @change="changeFilterStatusId"
                      ></el-checkbox>
                    </el-checkbox-group>

                    <div class="flex justify-between mt-4">
                      <span
                        class="text-xs cursor-pointer primary-theme-color"
                        @click="selectAllEmpId()"
                        >Select all</span
                      >
                      <span
                        class="text-xs cursor-pointer"
                        @click="resetSelectedEmpId()"
                        >Reset</span
                      >
                    </div>
                  </div>

                  <span slot="reference">
                    <img
                      v-if="!activeFilterId"
                      src="../../../../../src/assets/images/filterBlack.png"
                      width="9"
                      alt=""
                    />
                    <img
                      v-if="activeFilterId"
                      src="../../../../../src/assets/images/filter.png"
                      width="9"
                      alt=""
                    />
                  </span>
                </el-popover>
              </th>
              <th>
                {{ nameHeader }}

                <el-popover placement="bottom" trigger="click">
                  <div>
                    <el-checkbox-group v-model="selected_emp_name">
                      <el-checkbox
                        v-for="(empName, name_index) in empNameArray"
                        :key="name_index"
                        class="mb-2 checkbox-lable"
                        :label="empName.text"
                        style="display: block"
                        @change="changeFilterStatusName"
                      ></el-checkbox>
                    </el-checkbox-group>

                    <div class="flex justify-between mt-4">
                      <span
                        class="text-xs cursor-pointer primary-theme-color"
                        @click="selectAllEmpName()"
                        >Select all</span
                      >
                      <span
                        class="text-xs cursor-pointer"
                        @click="resetSelectedEmpName()"
                        >Reset</span
                      >
                    </div>
                  </div>

                  <span slot="reference">
                    <img
                      v-if="!activeFilter"
                      src="../../../../../src/assets/images/filterBlack.png"
                      width="9"
                      alt=""
                    />
                    <img
                      v-if="activeFilter"
                      src="../../../../../src/assets/images/filter.png"
                      width="9"
                      alt=""
                    />
                  </span>
                </el-popover>
              </th>
              <th v-if="view == 'daily' && basics == 'employee'">
                Time in-out
              </th>
              <th style="width: 22%">
                Actual labour hrs
                <span>
                  <i
                    v-if="sort_by_ascending_actual_lab_hr"
                    class="el-icon-caret-top text-base cursor-pointer"
                    @click="sortByDescendingActualLbrHr()"
                  ></i>

                  <i
                    v-else
                    class="el-icon-caret-bottom text-base cursor-pointer"
                    @click="sortByAscendingActualLbrHr()"
                  ></i>
                </span>
              </th>
              <th>
                Sales(INR)
                <span>
                  <i
                    v-if="sort_by_ascending_sales"
                    class="el-icon-caret-top text-base cursor-pointer"
                    @click="sortByDescendingSales()"
                  ></i>

                  <i
                    v-else
                    class="el-icon-caret-bottom text-base cursor-pointer"
                    @click="sortByAscendingSales()"
                  ></i>
                </span>
              </th>
              <th>
                NOB
                <span>
                  <i
                    v-if="sort_by_ascending_trans"
                    class="el-icon-caret-top text-base cursor-pointer"
                    @click="sortByDescendingTrans()"
                  ></i>

                  <i
                    v-else
                    class="el-icon-caret-bottom text-base cursor-pointer"
                    @click="sortByAscendingTrans()"
                  ></i>
                </span>
              </th>
              <th style="width: 12%">
                IPT
                <span>
                  <i
                    v-if="sort_by_ascending_ipt"
                    class="el-icon-caret-top text-base cursor-pointer"
                    @click="sortByDescendingIpt()"
                  ></i>

                  <i
                    v-else
                    class="el-icon-caret-bottom text-base cursor-pointer"
                    @click="sortByAscendingIpt()"
                  ></i>
                </span>
              </th>

              <th style="width: 12%">
                ASP
                <span>
                  <i
                    v-if="sort_by_ascending_asp"
                    class="el-icon-caret-top text-base cursor-pointer"
                    @click="sortByDescendingAsp()"
                  ></i>

                  <i
                    v-else
                    class="el-icon-caret-bottom text-base cursor-pointer"
                    @click="sortByAscendingAsp()"
                  ></i>
                </span>
              </th>
              <th style="width: 12%">
                ABV
                <span>
                  <i
                    v-if="sort_by_ascending_ats"
                    class="el-icon-caret-top text-base cursor-pointer"
                    @click="sortByDescendingAts()"
                  ></i>

                  <i
                    v-else
                    class="el-icon-caret-bottom text-base cursor-pointer"
                    @click="sortByAscendingAts()"
                  ></i>
                </span>
              </th>
              <!-- <th v-if="basics == 'employee'">
                Store Sales
                <span>
                  <i
                    v-if="sort_by_ascending_total_sales"
                    class="el-icon-caret-top text-base cursor-pointer"
                    @click="sortByDescendingTotalSales()"
                  ></i>

                  <i
                    v-else
                    class="el-icon-caret-bottom text-base cursor-pointer"
                    @click="sortByAscendingTotalSales()"
                  ></i>
                </span>
              </th> -->
            </tr>
          </thead>
          <tbody v-if="getEventsList.length">
            <tr v-for="(i, index) in getEventsList" :key="index">
              <td v-if="view == 'daily'">
                {{ i.for_date }}
              </td>
              <td v-if="basics == 'employee'">{{ i.emp_id }}</td>
              <td>
                <p class="break-words" v-if="nameHeader == 'emp name'">
                  {{ i.name }}
                </p>
                <p
                  v-if="nameHeader != 'emp name'"
                  class="break-words region-names"
                  @click="changeTblData(i.name, i.basics, nameHeader)"
                >
                  {{ i.name }}
                </p>
              </td>
              <td v-if="view == 'daily' && basics == 'employee'">
                {{ i.startEndTm ? i.startEndTm : "-" }}
              </td>

              <td style="width: 22%">
                {{
                  i.actual_labour_hours > 1
                    ? i.actual_labour_hours + " HRS"
                    : i.actual_labour_hours + " HR"
                }}
              </td>
              <td>
                <p v-if="basics == 'employee'">
                  {{ i.in_outlet_sales }}
                </p>
                <p v-if="basics != 'employee'">
                  {{ i.total_sales }}
                </p>
              </td>
              <td>{{ i.trans }}</td>

              <td style="width: 12%">{{ i.ipt }}</td>
              <td>
                {{ i.asp ? i.asp : "-" }}
              </td>
              <td style="width: 12%">{{ i.ats }}</td>
              <!-- <td v-if="basics == 'employee'">{{ i.total_sales }}</td> -->
            </tr>
          </tbody>
        </table>

        <div
          v-if="!getEventsList.length"
          class="text-center primary-theme-color text-sm font-semibold"
          style="padding: 15px"
        >
          No data available
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { serverAddr, serverAddrForCSV } from "../../../../networkConfig";
import moment from "moment";
import LabourPalnningService from "../../../../services/labourPalnningService";
import BaseCategoriesDropdown from "../../../baseCategoriesDD/BaseCategoriesDD.vue";
import BaseLocationsSingleSelect from "../../../baseLocationSingleSelect/BaseLocationSingleSelect.vue";
import CommonService from "../../../../services/commonService";

export default {
  name: "Performance",

  components: {
    BaseCategoriesDropdown,
    BaseLocationsSingleSelect,
  },
  props: {
    filterDepartmentList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      viewList: [
        // {
        //   name: "Daily",
        //   id: "daily",
        //   isDisabled: false,
        // },
        {
          name: "Week To Date",
          id: "wtd",
          isDisabled: false,
        },
        {
          name: "Month To Date",
          id: "mtd",
          isDisabled: false,
        },
        {
          name: "Year To Date",
          id: "ytd",
          isDisabled: false,
        },
        {
          name: "Custom Date",
          id: "customDt",
          isDisabled: false,
        },
      ],
      employeeList: [
        {
          name: "Select Employee",
          id: "",
          isDisabled: true,
        },
        {
          name: "Sameer",
          id: "1",
          isDisabled: false,
        },
        {
          name: "Kalyan",
          id: "2",
          isDisabled: false,
        },
        {
          name: "Naveen",
          id: "3",
        },
        {
          name: "Rajesh",
          id: "4",
        },
      ],
      categoryList: [
        {
          name: "Select Category",
          id: "",
          isDisabled: true,
        },
        {
          name: "A",
          id: "1",
          isDisabled: false,
        },
        {
          name: "B",
          id: "2",
          isDisabled: false,
        },
        {
          name: "C",
          id: "3",
        },
        {
          name: "D",
          id: "4",
        },
      ],
      category: "",
      view: "wtd",
      employee: "",
      fromDate: "",
      toDate: "",
      tableData: [],
      tableDataTwo: [],
      loading: false,
      basics: "",
      nameHeader: "region",
      pageInfo: {
        currentPage: 1,
        pageSize: 5,
        count: 0,
      },
      filters: {
        countries: [],
        regions: [],
        subregions: [],
        outlets: [],
        departments: [],
        categories: [],
        subcategories: [],
        products: [],
      },
      select_week: moment(),
      current_date: moment(),
      store_list: [],
      moment: moment,
      selected_store: "",
      selected_category: "",
      summary: {},
      empIdArray: [],
      empNameArray: [],
      breadcrumbs: [
        {
          name: "",
          type: "",
          id: "",
        },
        {
          name: "",
          type: "",
          id: "",
        },
        {
          name: "",
          type: "",
          id: "",
        },
        {
          name: "",
          type: "",
          id: "",
        },
      ],
      selected_emp_id: [],
      selected_emp_name: [],

      sort_by_ascending_date: false,
      sort_by_descending_date: false,

      sort_by_ascending_actual_lab_hr: false,
      sort_by_descending_actual_lab_hr: false,

      sort_by_ascending_sales: false,
      sort_by_descending_sales: false,

      sort_by_ascending_trans: false,
      sort_by_descending_trans: false,

      sort_by_ascending_ipt: false,
      sort_by_descending_ipt: false,

      sort_by_ascending_ats: false,
      sort_by_descending_ats: false,

      sort_by_ascending_asp: false,
      sort_by_descending_asp: false,

      sort_by_ascending_total_sales: false,
      sort_by_descending_total_sales: false,

      activeFilter: false,
      activeFilterId: false,
      selectedCountry: [],
      datePickerOptions: {
        disabledDate: this.disabledDueDate,
        firstDayOfWeek: 1,
      },
      disabledStartDate: {
        disabledDate: this.disabledToDate,
        firstDayOfWeek: 1,
      },
      pageLoading: false,
      user_access_level: "",
      isCSVDownloading : false,
      csvFileName: ''
    };
  },

  computed: {
    getEventsList() {
      let event_list = this.tableData;

      // Ascending decending for date

      if (this.sort_by_ascending_date) {
        event_list = event_list
          .slice()
          .sort((a, b) => new Date(b.for_date) - new Date(a.for_date));
      }

      if (this.sort_by_descending_date) {
        event_list = event_list
          .slice()
          .sort((a, b) => new Date(a.for_date) - new Date(b.for_date));
      }

      // Ascending decending for Actual labour hrs

      if (this.sort_by_ascending_actual_lab_hr) {
        event_list = event_list
          .slice()
          .sort((a, b) => b.actual_labour_hours - a.actual_labour_hours);
      }

      if (this.sort_by_descending_actual_lab_hr) {
        event_list = event_list
          .slice()
          .sort((a, b) => a.actual_labour_hours - b.actual_labour_hours);
      }
      // Ascending decending for transactions
      if (this.sort_by_ascending_sales) {
        event_list = event_list.slice().sort((a, b) => b.trans - a.trans);
      }

      if (this.sort_by_descending_sales) {
        event_list = event_list.slice().sort((a, b) => a.trans - b.trans);
      }
      // Ascending decending for Sales
      if (this.sort_by_ascending_sales) {
        event_list = event_list.slice().sort((a, b) => b.trans - a.trans);
      }

      if (this.sort_by_descending_sales) {
        event_list = event_list.slice().sort((a, b) => a.trans - b.trans);
      }

      // Ascending decending for Sales
      if (this.sort_by_ascending_trans) {
        event_list = event_list.slice().sort((a, b) => b.trans - a.trans);
      }

      if (this.sort_by_descending_trans) {
        event_list = event_list.slice().sort((a, b) => a.trans - b.trans);
      }
      // Ascending decending for IPT
      if (this.sort_by_ascending_ipt) {
        event_list = event_list.slice().sort((a, b) => b.ipt - a.ipt);
      }

      if (this.sort_by_descending_ipt) {
        event_list = event_list.slice().sort((a, b) => a.ipt - b.ipt);
      }
      // Ascending decending for ATS
      if (this.sort_by_ascending_ats) {
        event_list = event_list.slice().sort((a, b) => b.ats - a.ats);
      }

      if (this.sort_by_descending_ats) {
        event_list = event_list.slice().sort((a, b) => a.ats - b.ats);
      }

      // Ascending decending for ASP
      if (this.sort_by_ascending_asp) {
        event_list = event_list.slice().sort((a, b) => b.asp - a.asp);
      }

      if (this.sort_by_ascending_asp) {
        event_list = event_list.slice().sort((a, b) => a.asp - b.asp);
      }

      // Ascending decending for total_sales
      if (this.sort_by_ascending_total_sales) {
        event_list = event_list
          .slice()
          .sort((a, b) => b.total_sales - a.total_sales);
      }

      if (this.sort_by_descending_total_sales) {
        event_list = event_list
          .slice()
          .sort((a, b) => a.total_sales - b.total_sales);
      }

      // filter functions
      if (this.selected_emp_id.length) {
        event_list = event_list
          .slice()
          .filter((e) => this.selected_emp_id.indexOf(e.emp_id) > -1);
      }

      if (this.selected_emp_name.length) {
        event_list = event_list
          .slice()
          .filter((e) => this.selected_emp_name.indexOf(e.name) > -1);
      }

      return event_list;
    },
  },
  mounted() {
    this.user_access_level = localStorage.getItem("user_access_level");
    if (this.user_access_level == "admin") {
      this.basics = "region";
      this.csvFileName = 'India'
      this.getLocations();
    } else if (this.user_access_level == "region") {
      this.basics = "subregion";
    } else if (this.user_access_level == "subregion") {
      this.basics = "outlet";
    } else if (this.user_access_level == "outlet") {
      this.basics = "employee";
    } else if (this.user_access_level == "employee") {
      this.basics = "employee";
    }

    this.showDateByQueryReport("wtd");
    // this.getPerformanceData()
  },
  created() {},

  methods: {
    reportCSVDownload() {

      this.csvFileName =  this.csvFileName.charAt(0).toUpperCase() + this.csvFileName.slice(1);
      var nameStr = 'Performance Report of ' + this.csvFileName + ' from ' + this.fromDate + ' to ' + this.toDate;

      this.isCSVDownloading = true;
      var view = "";
      if (this.view == "customDt") {
        view = null;
      } else {
        view = this.view;
      }
      var params = {
        start_date: this.fromDate,
        end_date: this.toDate,
        quickreport: view,
        basics: this.basics,
        filters: this.filters,
      };
      serverAddrForCSV
        .post(`/sales/employee/analytics/download/`, params)
        .then((response) => {
          if (response.status == 200) {
            var data = response.data;

            let urlData =
              "data:text/csv;charset=UTF-8," + encodeURIComponent(data);

            var tempLink = document.createElement("a");
            tempLink.href = urlData;
            tempLink.setAttribute("download", `${nameStr}.csv`);
            tempLink.click();
            this.isCSVDownloading = false;
          }
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    disabledDueDate(time) {
      return time.getTime() > Date.now() - 8.64e7;
    },
    disabledToDate(time) {
      var fromDate = new Date(this.fromDate);
      // console.log(time , fromDate);
      fromDate = fromDate.getTime();
      if (time.getTime() <= fromDate - 8.64e7) {
        return time.getTime() < fromDate - 8.64e7;
      } else {
        return time.getTime() > Date.now() - 8.64e7;
      }
    },
    getLocations(args) {
      this.basics = "region";
      this.pageLoading = true;
      CommonService.getLocations(args)
        .then((response) => {
          var obj = JSON.parse(response.data).results[0];
          this.selectedCountry = [
            {
              id: obj.id,
              name: obj.name,
              type: obj.type,
              active: true,
              isSelected: false,
            },
          ];
          this.breadcrumbs[0].name = obj.name;
          this.breadcrumbs[0].type = obj.type;
          this.breadcrumbs[0].id = obj.id;
          this.filters = {
            countries: [obj.id],
            regions: [],
            subregions: [],
            outlets: [],
          };
          this.csvFileName = obj.name;
          setTimeout(() => {
            this.getPerformanceData();
          }, 1000);

          this.pageLoading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeFilterStatusName() {
      if (this.selected_emp_name.length) {
        this.activeFilter = true;
      } else {
        this.activeFilter = false;
      }
    },

    selectAllEmpName() {
      this.activeFilter = true;
      this.selected_emp_name = [];
      for (let i in this.empNameArray) {
        this.selected_emp_name.push(this.empNameArray[i].text);
      }
    },

    resetSelectedEmpName() {
      this.activeFilter = false;
      this.selected_emp_name = [];
    },

    changeFilterStatusId() {
      if (this.selected_emp_id.length) {
        this.activeFilterId = true;
      } else {
        this.activeFilterId = false;
      }
    },
    selectAllEmpId() {
      this.activeFilterId = true;
      this.selected_emp_id = [];
      for (let i in this.empIdArray) {
        this.selected_emp_id.push(this.empIdArray[i].text);
      }
    },

    resetSelectedEmpId() {
      this.activeFilterId = false;
      this.selected_emp_id = [];
    },

    sortByDescendingDate() {
      this.allFalse();

      // toggled arrows
      this.sort_by_ascending_date = false;
      this.sort_by_descending_date = true;
    },

    sortByAscendingDate() {
      this.allFalse();

      // toggled arrows
      this.sort_by_ascending_date = true;
      this.sort_by_descending_date = false;
    },
    sortByDescendingActualLbrHr() {
      this.allFalse();

      // toggled arrows
      this.sort_by_ascending_actual_lab_hr = false;
      this.sort_by_descending_actual_lab_hr = true;
    },

    sortByAscendingActualLbrHr() {
      this.allFalse();

      // toggled arrows
      this.sort_by_ascending_actual_lab_hr = true;
      this.sort_by_descending_actual_lab_hr = false;
    },

    sortByDescendingSales() {
      this.allFalse();

      // toggled arrows
      this.sort_by_ascending_sales = false;
      this.sort_by_descending_sales = true;
    },

    sortByAscendingSales() {
      this.allFalse();
      // toggled arrows
      this.sort_by_ascending_sales = true;
      this.sort_by_descending_sales = false;
    },
    sortByDescendingTrans() {
      this.allFalse();

      // toggled arrows
      this.sort_by_ascending_trans = false;
      this.sort_by_descending_trans = true;
    },

    sortByAscendingTrans() {
      this.allFalse();
      // toggled arrows
      this.sort_by_ascending_trans = true;
      this.sort_by_descending_trans = false;
    },

    sortByDescendingIpt() {
      this.allFalse();

      // toggled arrows
      this.sort_by_ascending_ipt = false;
      this.sort_by_descending_ipt = true;
    },

    sortByAscendingIpt() {
      this.allFalse();
      // toggled arrows
      this.sort_by_ascending_ipt = true;
      this.sort_by_descending_ipt = false;
    },

    sortByDescendingAts() {
      this.allFalse();

      // toggled arrows
      this.sort_by_ascending_ats = false;
      this.sort_by_descending_ats = true;
    },

    sortByAscendingAts() {
      this.allFalse();
      // toggled arrows
      this.sort_by_ascending_ats = true;
      this.sort_by_descending_ats = false;
    },

    sortByDescendingAsp() {
      this.allFalse();

      // toggled arrows
      this.sort_by_ascending_asp = false;
      this.sort_by_descending_asp = true;
    },

    sortByAscendingAsp() {
      this.allFalse();
      // toggled arrows
      this.sort_by_ascending_asp = true;
      this.sort_by_descending_asp = false;
    },

    sortByDescendingTotalSales() {
      this.allFalse();

      // toggled arrows
      this.sort_by_ascending_total_sales = false;
      this.sort_by_descending_total_sales = true;
    },

    sortByAscendingTotalSales() {
      this.allFalse();
      // toggled arrows
      this.sort_by_ascending_total_sales = true;
      this.sort_by_descending_total_sales = false;
    },

    allFalse() {
      this.sort_by_ascending_date = false;
      this.sort_by_descending_date = false;
      this.sort_by_ascending_actual_lab_hr = false;
      this.sort_by_descending_actual_lab_hr = false;
      this.sort_by_ascending_sales = false;
      this.sort_by_descending_sales = false;
      this.sort_by_ascending_trans = false;
      this.sort_by_descending_trans = false;
      this.sort_by_ascending_ipt = false;
      this.sort_by_descending_ipt = false;
      this.sort_by_ascending_ats = false;
      this.sort_by_descending_ats = false;
      this.sort_by_ascending_asp = false;
      this.sort_by_descending_asp = false;
      this.sort_by_ascending_total_sales = false;
      this.sort_by_descending_total_sales = false;
    },

    changeTblData(name, id, type) {
      if (type == "country") {
        this.filters = {
          countries: [id],
          regions: [],
          subregions: [],
          outlets: [],
        };
        this.resetBreadCrumbs();
        this.breadcrumbs[0].name = name;
        this.breadcrumbs[0].type = type;
        this.breadcrumbs[0].id = id;
        this.basics = "region";
      } else if (type == "region") {
        this.filters = {
          countries: [],
          regions: [id],
          subregions: [],
          outlets: [],
        };
        this.basics = "subregion";

        this.breadcrumbs[1].name = name;
        this.breadcrumbs[1].type = type;
        this.breadcrumbs[1].id = id;

        this.breadcrumbs[2].name = "";
        this.breadcrumbs[2].type = "";
        this.breadcrumbs[2].id = "";

        this.breadcrumbs[3].name = "";
        this.breadcrumbs[3].type = "";
        this.breadcrumbs[3].id = "";
      } else if (type == "subregion") {
        this.filters = {
          countries: [],
          regions: [],
          subregions: [id],
          outlets: [],
        };
        this.basics = "outlet";
        this.breadcrumbs[2].name = name;
        this.breadcrumbs[2].type = type;
        this.breadcrumbs[2].id = id;

        this.breadcrumbs[3].name = "";
        this.breadcrumbs[3].type = "";
        this.breadcrumbs[3].id = "";
      } else if (type == "store") {
        this.filters = {
          countries: [],
          regions: [],
          subregions: [],
          outlets: [id],
        };
        this.basics = "employee";
        this.breadcrumbs[3].name = name;
        this.breadcrumbs[3].type = type;
        this.breadcrumbs[3].id = id;
      }
      this.csvFileName = name;
      this.getPerformanceData();
    },

    categoryDropDownUpdate(categoryDDUpdate) {
      let id = categoryDDUpdate.cat_selected.map((e) => {
        return e.id;
      });
      if (categoryDDUpdate.cat_basics == "department") {
        this.filters.departments = id;
      } else if (categoryDDUpdate.cat_basics == "category") {
        this.filters.categories = id;
      } else if (categoryDDUpdate.cat_basics == "subcategory") {
        this.filters.subcategories = id;
      } else if (categoryDDUpdate.cat_basics == "product") {
        this.filters.products = id;
      }
    },

    showDateByQueryReport(view) {
      if (view == "wtd") {
        let date = "";

        // this.select_week = new Date();
        date = this.select_week;

        var dt = new Date(date); // current date of week
        var currentWeekDay = dt.getDay();
        var lessDays = currentWeekDay == 0 ? 6 : currentWeekDay - 1;
        var wkStart = new Date(new Date(dt).setDate(dt.getDate() - lessDays));

        let wkEnd = "";
        wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));

        if (wkEnd > new Date() && wkStart < new Date()) {
          wkEnd = new Date();
        }

        this.fromDate = moment(wkStart).format("YYYY-MM-DD");

        this.toDate = moment(wkEnd).format("YYYY-MM-DD");
      } else if (view == "daily" || view == "customDt") {
        var pastDate = moment().subtract(1, "days");
        this.fromDate = moment(pastDate).format("YYYY-MM-DD");
        this.toDate = moment(pastDate).format("YYYY-MM-DD");
      } else if (view == "mtd") {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        this.fromDate = moment(firstDay).format("YYYY-MM-DD");
        this.toDate = moment(date).format("YYYY-MM-DD");
      } else if (view == "ytd") {
        var date = new Date(new Date().getFullYear(), 0, 1);
        this.fromDate = moment(date).format("YYYY-MM-DD");
        this.toDate = moment(new Date()).format("YYYY-MM-DD");
      }

      // this.getPerformanceData();
      // this.custom_date_format = `${this.start_date} To ${this.end_date}`;
    },
    getPerformanceData() {
      var view = "";
      if (this.view == "customDt") {
        view = null;
      } else {
        view = this.view;
      }
      this.loading = true;
      serverAddr
        .post(`/sales/employee/analytics/`, {
          start_date: this.fromDate,
          end_date: this.toDate,
          quickreport: view,
          basics: this.basics,
          filters: this.filters,
        })
        .then((response) => {
          if (response.status == 200) {
            if (this.basics == "region") {
              this.nameHeader = "region";
            } else if (this.basics == "subregion") {
              this.nameHeader = "subregion";
            } else if (this.basics == "outlet") {
              this.nameHeader = "store";
            } else if (this.basics == "employee") {
              this.nameHeader = "emp name";
            }

            this.tableData = [];
            this.loading = false;
            var res = JSON.parse(response.data);
            this.tableData = res.data;

            this.tableData.forEach((element) => {
              if (element.start_time) {
                var startEndTm =
                  element.start_time.slice(0, 5) +
                  " - " +
                  element.end_time.slice(0, 5);
                element.startEndTm = startEndTm;
              }
            });
            this.summary = res.summary;

            let empIdArray = this.tableData.map((element) => element.emp_id);

            empIdArray = Array.from(new Set(empIdArray));
            this.empIdArray = empIdArray.map((element) => {
              return {
                text: element,
                value: element,
              };
            });

            let empNameArray = this.tableData.map((element) => element.name);
            empNameArray = Array.from(new Set(empNameArray));
            this.empNameArray = empNameArray.map((element) => {
              return {
                text: element,
                value: element,
              };
            });
          }
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    resetBreadCrumbs() {
      this.breadcrumbs = [
        {
          name: "",
          type: "",
          id: "",
        },
        {
          name: "",
          type: "",
          id: "",
        },
        {
          name: "",
          type: "",
          id: "",
        },
        {
          name: "",
          type: "",
          id: "",
        },
      ];
    },
    // filterEmpId(value, row) {
    //   return row.emp_id === value;
    // },
    // filterEmpNameId(value, row) {
    //   return row.name === value;
    // },

    dropDownUpdate(update) {
      this.resetBreadCrumbs();
      if (update.selected.length < 1) {
        this.getLocations();
        return;
      }

      this.newBasics = update.basics;
      // console.log("update", update.selected);

      this.outlets = [];
      this.countris = [];
      this.regions = [];
      this.subregions = [];

      let selectedLocation = update.selected;

      if (update.selected.length) {
        if (update.basics == "subregion") {
          this.subregions = selectedLocation.map((e) => {
            this.breadcrumbs[2].name = e.name;
            this.breadcrumbs[2].type = update.basics;
            this.breadcrumbs[2].id = e.id;
            this.filters = {
              countries: [],
              regions: [],
              subregions: [e.id],
              // subregions: update.selected.map((e) => {
              //   return e.id;
              // }),
              outlets: [],
            };
            this.csvFileName = e.name;
            return { id: e.id };
          });
        } else if (update.basics == "country") {
          this.countris = selectedLocation.map((e) => {
            this.breadcrumbs[0].name = e.name;
            this.breadcrumbs[0].type = update.basics;
            this.breadcrumbs[0].id = e.id;
            this.filters = {
              // countries: update.selected.map((e) => {
              //   return e.id;
              // }),
              countries: [e.id],
              regions: [],
              subregions: [],
              outlets: [],
            };
            this.csvFileName = e.name;
            return { id: e.id };
          });
        } else if (update.basics == "region") {
          this.regions = selectedLocation.map((e) => {
            this.breadcrumbs[1].name = e.name;
            this.breadcrumbs[1].type = update.basics;
            this.breadcrumbs[1].id = e.id;
            this.filters = {
              countries: [],
              // regions: update.selected.map((e) => {
              //   return e.id;
              // }),
              regions: [e.id],
              subregions: [],
              outlets: [],
            };
            this.csvFileName = e.name;
            return { id: e.id };
          });
        } else if (update.basics == "outlet") {
          this.outlets = selectedLocation.map((e) => {
            this.breadcrumbs[3].name = e.name;
            this.breadcrumbs[3].type = update.basics;
            this.breadcrumbs[3].id = e.id;
            this.filters = {
              countries: [],
              regions: [],
              subregions: [],
              outlets: [e.id],

              // outlets: update.selected.map((e) => {
              //   return e.id;
              // }),
            };
            this.csvFileName = e.name;
            return { id: e.id };
          });
        }
      }
      if (update.basics == "country") {
        this.basics = "region";
      } else if (update.basics == "region") {
        this.basics = "subregion";
      } else if (update.basics == "subregion") {
        this.basics = "outlet";
      } else if (update.basics == "outlet") {
        this.basics = "employee";
      }

      if (update.list && update.list.length) {
        for (let country = 0; country < update.list.length; country++) {
          if (!update.list[country].isSelected) {
            for (
              let region = 0;
              region < update.list[country].regions.length;
              region++
            ) {
              if (!update.list[country].regions[region].isSelected) {
                for (
                  let subregion = 0;
                  subregion <
                  update.list[country].regions[region].subregions.length;
                  subregion++
                ) {
                  if (
                    !update.list[country].regions[region].subregions[subregion]
                      .isSelected
                  ) {
                    for (
                      let store = 0;
                      store <
                      update.list[country].regions[region].subregions[subregion]
                        .outlets.length;
                      store++
                    ) {
                      if (
                        !update.list[country].regions[region].subregions[
                          subregion
                        ].outlets[store].isSelected
                      ) {
                      } else {
                        this.breadcrumbs[0].name = update.list[country].name;
                        this.breadcrumbs[0].type = update.list[country].type;
                        this.breadcrumbs[0].id = update.list[country].id;

                        this.breadcrumbs[1].name =
                          update.list[country].regions[region].name;
                        this.breadcrumbs[1].type =
                          update.list[country].regions[region].type;
                        this.breadcrumbs[1].id =
                          update.list[country].regions[region].id;

                        this.breadcrumbs[2].name =
                          update.list[country].regions[region].subregions[
                            subregion
                          ].name;
                        this.breadcrumbs[2].type =
                          update.list[country].regions[region].subregions[
                            subregion
                          ].type;
                        this.breadcrumbs[2].id =
                          update.list[country].regions[region].subregions[
                            subregion
                          ].id;
                      }
                    }
                  } else {
                    this.breadcrumbs[0].name = update.list[country].name;
                    this.breadcrumbs[0].type = update.list[country].type;
                    this.breadcrumbs[0].id = update.list[country].id;

                    this.breadcrumbs[1].name =
                      update.list[country].regions[region].name;
                    this.breadcrumbs[1].type =
                      update.list[country].regions[region].type;
                    this.breadcrumbs[1].id =
                      update.list[country].regions[region].id;

                    this.breadcrumbs[3].name = "";

                    this.breadcrumbs[3].type = "";

                    this.breadcrumbs[3].id = "";
                  }
                }
              } else {
                this.breadcrumbs[0].name = update.list[country].name;
                this.breadcrumbs[0].type = update.list[country].type;
                this.breadcrumbs[0].id = update.list[country].id;

                this.breadcrumbs[2].name = "";
                this.breadcrumbs[2].type = "";
                this.breadcrumbs[2].id = "";

                this.breadcrumbs[3].name = "";
                this.breadcrumbs[3].type = "";
                this.breadcrumbs[3].id = "";
              }
            }
          } else {
            this.breadcrumbs[1].name = "";
            this.breadcrumbs[1].type = "";
            this.breadcrumbs[1].id = "";

            this.breadcrumbs[2].name = "";
            this.breadcrumbs[2].type = "";
            this.breadcrumbs[2].id = "";

            this.breadcrumbs[3].name = "";
            this.breadcrumbs[3].type = "";
            this.breadcrumbs[3].id = "";
          }
        }
      }

      this.tableData = [];
    },
  },
};
</script>



<style lang="scss" scoped>
@import "./Performance.scss";
</style>
<style lang="scss">
.performance {
  table {
    width: 100% !important;
  }
  .el-table .cell {
    text-align: center !important;
    word-break: normal;
  }
  .el-table th > .cell {
    font-size: 11px !important;
    color: #1d1c1c !important;
    padding-left: 3px !important;
    padding-right: 3px !important;
  }
  .el-table--enable-row-transition .el-table__body td {
    font-size: 12px;
    text-align: center;
    // color: #000000 !important;
  }

  .csv-btn {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
    padding: 5px;
    font-size: 12px;
    font-weight: 600;
    border: 2px solid;
    width: 60px;
    height: 30px;
    text-align: center;
    border-radius: 3px;
  }
}
</style>
<style>
.performance .el-icon-arrow-down:before {
  content: "\e790" !important;
}
.performance .el-icon-arrow-down {
  font-size: 20px !important;
}
</style>
